import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

export default function AdminPage() {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div className="min-h-screen bg-[#06080E] flex items-center justify-center" data-testid="admin-loading">
        <div className="w-8 h-8 rounded-full border-2 border-[#FF8800] border-t-transparent animate-spin" />
      </div>
    );
  }

  return admin ? <AdminDashboard /> : <AdminLogin />;
}
